import React, { Component } from "react";
import PropTypes from "prop-types";
import Row from "../../shared_modules/common/grid/Row";
import Col from "../../shared_modules/common/grid/Col";
import Name from "./Name";
import Address from "./Address";

class PI1FormNameAddress extends Component {
  constructor(props) {
    super(props);
  }

  static defaultProps = {
    secName: "sectionAddress",
    secTitle: "Applicant Information",
    sectionStatus: "",
    nameDisabled: true,
    colLayout: { sm: 12, lg: 3 },
  };

  handleEventCallback = (ev, data) => {
    const { name, id } = ev.target,
      {
        onSectionCallback,
        onAddrToggleCallback,
        secName,
        onStateChgCallback,
        sectionMetadata,
      } = this.props;

    let fieldName = name;

    if (name === "firstname") {
      fieldName = "applicantFN";
    } else if (name === "lastname") {
      fieldName = "applicantLN";
    } else {
      fieldName = "address";
    }

    sectionMetadata.fields[fieldName] = data;

    if (ev.type === "change" && name === "state") {
      // check for MA state
      if (onStateChgCallback && typeof onStateChgCallback === "function") {
        onStateChgCallback(id, sectionMetadata.fields[fieldName]);
      }
    } else {
      if (name.indexOf("addrsame") !== -1) {
        if (
          onAddrToggleCallback &&
          typeof onAddrToggleCallback === "function"
        ) {
          onAddrToggleCallback(
            secName,
            sectionMetadata.fields.address.isSameAddr,
          );
        }
      } else {
        if (fieldName === "address" && name === "smartyStreetsSuggestion") {
          if (onStateChgCallback && typeof onStateChgCallback === "function") {
            onStateChgCallback(id, sectionMetadata.fields[fieldName]);
          }
        }

        if (onSectionCallback && typeof onSectionCallback === "function") {
          onSectionCallback(
            secName,
            fieldName,
            sectionMetadata.fields[fieldName],
          );
        }
      }
    }
  };

  render() {
    const {
      secTitle,
      colLayout,
      nameDisabled,
      sectionMetadata,
      loanAmount,
      MA_minAmt,
      useMinAmountForMA,
    } = this.props;
    return (
      <fieldset className="pf-registration section-2 applicant-address">
        <legend className="show-for-sr">Applicant address</legend>
        <Row className="overflow-visible">
          <Col className="heading" width={colLayout}>
            <h2 className="label">{secTitle}</h2>
          </Col>
        </Row>
        <Name
          nameType="applicant"
          nameGroupLabel="Applicant name"
          onEventCallback={this.handleEventCallback}
          nameDisabled={nameDisabled}
          firstNameMetadata={sectionMetadata.fields.applicantFN}
          lastNameMetadata={sectionMetadata.fields.applicantLN}
        />
        <Address
          onEventCallback={this.handleEventCallback}
          addressSectionMetadata={sectionMetadata.fields.address}
          loanAmount={loanAmount}
          MA_minAmt={MA_minAmt}
          useMinAmountForMA={useMinAmountForMA}
        />
      </fieldset>
    );
  }
}

PI1FormNameAddress.propTypes = {
  secTitle: PropTypes.string.isRequired,
  colLayout: PropTypes.object.isRequired,
  nameDisabled: PropTypes.bool,
  sectionMetadata: PropTypes.object.isRequired,
  onSectionCallback: PropTypes.func.isRequired,
  sectionStatus: PropTypes.string.isRequired,
  onAddrToggleCallback: PropTypes.func.isRequired,
  onStateChgCallback: PropTypes.func.isRequired,
  secName: PropTypes.string,
  loanAmount: PropTypes.string.isRequired,
  MA_minAmt: PropTypes.number.isRequired,
  useMinAmountForMA: PropTypes.bool.isRequired,
};

export default PI1FormNameAddress;

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');